module.exports = __webpack_public_path__ + "img/2.73e4fdeb.png";